'use strict'

import '@fancyapps/fancybox'
import 'bootstrap'
// import Carousel from './Components/Carousel'
import FrontendLogin from './Components/FrontendLogin'
// import GoogleMap from './Components/GoogleMap'
// import Paginator from './Components/Paginator'
// import Powermail from './Components/Powermail'
// import Slider from './Components/slider'

export default class Application {
  constructor () {
    this
      // ._initializeCarousel()
      ._initializeFrontendLogin()
      // ._initializeGoogleMap()
      // ._initializeNewsPaginator()
      // ._initializeNewsSlider()
      // ._initializePowermail()

    return this
  }

  /*
  _initializeCarousel () {
    (() => new Carousel().randomize())()

    return this
  }
  */

  _initializeFrontendLogin () {
    (() => new FrontendLogin())()

    return this
  }

  /*
  _initializeGoogleMap () {
    (() => new GoogleMap())()

    return this
  }
  */

  /*
  _initializeNewsPaginator () {
    (() => new Paginator('news').paginate())()

    return this
  }
  */

  /*
  _initializeNewsSlider () {
    (() => new Slider('.news-slider').slide())()

    return this
  }
  */

  /*
  _initializePowermail () {
    (() => new Powermail().send())()

    return this
  }
  */
}
